import { BaseReferralClient, InviteVariables, Invitation, DeleteInvitationVariables, ReferralStats } from "@core/types";

class ReferralClient extends BaseReferralClient {
  async invite(variables: InviteVariables): Promise<any> {
    throw new Error("invite not implemented");
  }

  async getInvitations(): Promise<Invitation[]> {
    throw new Error("getInvitations not implemented");
  }

  async deleteInvitation(variables: DeleteInvitationVariables): Promise<any> {
    throw new Error("deleteInvitation not implemented");
  }

  async getReferralPoints(): Promise<number> {
    const { data } = await this.instance.get(`/wp-json/parhato-api/v1/referral-points`);
    return data.points;
  }

  async checkWasInvited(variables: InviteVariables): Promise<any> {
    throw new Error("checkWasInvited not implemented");
  }

  async getReferralStats(): Promise<ReferralStats | null> {
    throw new Error("getReferralStats not implemented");
  }
}

export default ReferralClient;
